var _path, _g, _path2, _g2, _path3, _g3, _path4, _g4, _path5, _g5, _path6, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 51,
    height: 50,
    viewBox: "0 0 51 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_401_75",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 5,
    y: 0,
    width: 41,
    height: 50
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M45.7286 23.0719L32.2696 36.5358L45.7286 49.9996H30.349L16.8851 36.5358L30.349 23.0719H45.7286ZM30.349 0L5.35156 24.9974L13.0438 32.6896L45.7286 0H30.349Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_401_75)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.8906 36.5356L24.5781 44.2279L45.7293 23.0718H30.3497L16.8906 36.5356Z",
    fill: "#39CEFD"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_401_75",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 5,
    y: 0,
    width: 41,
    height: 50
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M45.7286 23.0719L32.2696 36.5358L45.7286 49.9996H30.349L16.8851 36.5358L30.349 23.0719H45.7286ZM30.349 0L5.35156 24.9974L13.0438 32.6896L45.7286 0H30.349Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_401_75)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M30.349 0H45.7286L13.0438 32.6896L5.35156 24.9974L30.349 0Z",
    fill: "#39CEFD"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_401_75",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 5,
    y: 0,
    width: 41,
    height: 50
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M45.7286 23.0719L32.2696 36.5358L45.7286 49.9996H30.349L16.8851 36.5358L30.349 23.0719H45.7286ZM30.349 0L5.35156 24.9974L13.0438 32.6896L45.7286 0H30.349Z",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_401_75)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.5781 44.2279L30.3497 49.9947H45.7294L32.2704 36.5356L24.5781 44.2279Z",
    fill: "#03569B"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask3_401_75",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 5,
    y: 0,
    width: 41,
    height: 50
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M45.7286 23.0719L32.2696 36.5358L45.7286 49.9996H30.349L16.8851 36.5358L30.349 23.0719H45.7286ZM30.349 0L5.35156 24.9974L13.0438 32.6896L45.7286 0H30.349Z",
    fill: "white"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask3_401_75)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M35.9865 40.2759L32.2704 36.5356L24.5781 44.2279L35.9865 40.2759Z",
    fill: "url(#paint0_linear_401_75)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask4_401_75",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 5,
    y: 0,
    width: 41,
    height: 50
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M45.7286 23.0719L32.2696 36.5358L45.7286 49.9996H30.349L16.8851 36.5358L30.349 23.0719H45.7286ZM30.349 0L5.35156 24.9974L13.0438 32.6896L45.7286 0H30.349Z",
    fill: "white"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask4_401_75)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.8887 36.5331L24.5811 28.8406L32.274 36.5331L24.5811 44.2256L16.8887 36.5331Z",
    fill: "#16B9FD"
  }))), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M45.7286 23.0719L32.2696 36.5358L45.7286 49.9996H30.349L16.8851 36.5358L30.349 23.0719H45.7286ZM30.349 0L5.35156 24.9974L13.0438 32.6896L45.7286 0H30.349Z",
    fill: "url(#paint1_radial_401_75)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_401_75",
    x1: 26.823,
    y1: 45.7124,
    x2: 32.552,
    y2: 39.9834,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1A237E",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1A237E",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_401_75",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(6.48589 3.40783) scale(61.1684 61.1684)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDart);
export default __webpack_public_path__ + "static/media/dart.a00cf66aa6ed6e37bdf83a28a33345d7.svg";
export { ForwardRef as ReactComponent };